export interface ActivityDetails {
  id:string,
  activityId: number;
  activityName: string;
  otherActivityName?: string;
  levelOfAchievement?: LevelOfAchievement | null;
  positionInActivity: string;
  organisationName: string | null;
  participationGradeLevels: string | null;
  startDate: Date | null;
  endDate: Date | null;
  location: string | null;
  textDescription: string | null;
  htmlDescription: string | null;
}

export interface ExtraCurricularActivityRequest {
  activityDetails: ActivityDetails[];
}

export enum LevelOfAchievement {
  Tier1 = 1,
  Tier2 = 2,
  Tier3 = 3,
  Tier4 = 4
}
